<h1 class="title-sect color-blue-dark font-30 f-31">
    Detalle de solicitud
  </h1>
  <div class="card shadow-item bg-white mg-btm-60 over-hiden col-xs-12">
    <h3 class="subtitle-sect color-blue-dark font-24 f-32">
      Informacion sobre el estado de su solicitud
    </h3>
      <div class="m-t-50">
          <div class="container">
            <div class="form-section container">
              <div class="container-form">
                <div>
                  <app-informacion></app-informacion>
                  <div class="info-titular bg-light-blue p-4 rounded-lg shadow-item mb-4">
                    <h2 class="color-blue-dark font-24 mb-2">Información de la solicitud</h2>
                    <p class="color-gray font-16">
                      <strong>Radicado:</strong>  {{solicitudDetalle?.radicado}}
                    </p>
                    <p class="color-gray font-16">
                      <strong>Fecha de radicacion:</strong> {{solicitudDetalle?.fechaRadicacion | date:'dd/MM/yyyy h:mm a' }}
                    </p>
                    <p class="color-gray font-16">
                      <strong>Fecha de actualizacion:</strong> {{solicitudDetalle?.fechaRadicacion | date:'dd/MM/yyyy h:mm a'}}
                    </p>
                    <p class="color-gray font-16">
                      <strong>Estado:</strong> {{ obtenerNombreEstado(solicitudDetalle?.solicitudEstado) }}
                    </p>
                  </div>

                  <div class="info-titular bg-light-blue p-4 rounded-lg shadow-item mb-4">
                    <h2 class="color-blue-dark font-24 mb-2">Información del Titular</h2>
                    <p class="color-gray font-16">
                      <strong>Nombre:</strong> {{solicitudDetalle?.titular?.primerNombre}} {{solicitudDetalle?.titular?.segundoNombre}} {{solicitudDetalle?.titular?.primerApellido}} {{solicitudDetalle?.titular?.segundoApellido}}
                    </p>
                    <p class="color-gray font-16">
                      <strong>Número de Documento:</strong> {{solicitudDetalle?.numeroIdentidadTitular}}
                    </p>
                  </div>

                  <mat-accordion>
                    <mat-expansion-panel *ngFor="let tipo of objectKeys(complementosAgrupados)">
                      <mat-expansion-panel-header>
                        <mat-panel-title> {{ tipo }} </mat-panel-title>
                      </mat-expansion-panel-header>

                      <table aria-label="Tabla de {{ tipo }}" class="rwd-table" width="100%">
                        <thead class="thead">
                          <tr>
                            <th>Parentesco</th>
                            <th>Número Documento</th>
                            <th>Nombre</th>
                            <th>Fecha de actualizacion</th>
                            <th>Estado</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let persona of complementosAgrupados[tipo]">
                            <td>{{ persona.parentesco }}</td>
                            <td>{{ persona.numeroDocumento }}</td>
                            <td>{{ persona.nombre }}</td>
                            <td>{{ persona.fechaActualizacion | date:'dd/MM/yyyy h:mm a' }}</td>
                            <td>{{ obtenerNombreEstado(persona.estado) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </mat-expansion-panel>
                  </mat-accordion>

                </div>
              </div>
              <br />

            </div>

            <div class="col-md-12">
              <div
                class="steps-cont_actions d-flex justify-content-center container"
              >

                <a
                  role="button"
                  appDebounceClick
                  id="Afiliacion_PTEC-afiliar-trabajador-regresar"
                  title="Volver"
                  href="javascript:history.back()"
                  routerLinkActive="router-link-active"
                  class="u-btn u-btn--line r-hide"
                  >Volver
                </a>
              </div>
            </div>
          </div>
      </div>
  </div>
